import React from 'react';

import { IIconProps, TIconType } from '../interface';

const HandIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='hand'
			fill='none'
			height='24'
			viewBox='0 0 18 22'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M13.75 9.5V8.375C13.75 7.87772 13.5525 7.40081 13.2008 7.04917C12.8492 6.69754 12.3723 6.5 11.875 6.5C11.3777 6.5 10.9008 6.69754 10.5492 7.04917C10.1975 7.40081 10 7.87772 10 8.375V2.375C10 1.87772 9.80246 1.40081 9.45083 1.04917C9.0992 0.697544 8.62228 0.5 8.125 0.5C7.62772 0.5 7.15081 0.697544 6.79918 1.04917C6.44755 1.40081 6.25 1.87772 6.25 2.375V13.7469L4.19688 10.1844C3.94824 9.75298 3.53841 9.43803 3.05756 9.30881C2.5767 9.17958 2.06421 9.24667 1.63282 9.49531C1.20143 9.74395 0.886475 10.1538 0.757251 10.6346C0.628026 11.1155 0.695114 11.628 0.943754 12.0594C4 18.5 5.85625 20.75 10 20.75C10.9849 20.75 11.9602 20.556 12.8701 20.1791C13.7801 19.8022 14.6069 19.2497 15.3033 18.5533C15.9997 17.8569 16.5522 17.0301 16.9291 16.1201C17.306 15.2102 17.5 14.2349 17.5 13.25V9.5C17.5 9.00272 17.3025 8.52581 16.9508 8.17417C16.5992 7.82254 16.1223 7.625 15.625 7.625C15.1277 7.625 14.6508 7.82254 14.2992 8.17417C13.9475 8.52581 13.75 9.00272 13.75 9.5V9.5Z'
				fill='currentColor'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default HandIcon;
